import axios from "axios";
import Api from "../../config/api/axios.urlcontext"
export default class PresupuestoDeEgresos{
    async getPresupuestoEgresos(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getListadoAniosTrimMunicipios(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getAllContenidoSRFTM(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }

    async getListadoAniosTrimOP(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getAllContenidoSRFTOP(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }


    async getListadoAniosTrimMunicipiosSFU(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getAllContenidoSFU(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }

    async getListadoAniosTrimOPSFU(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
    async getAllContenidoSFUOP(url) {
        try {
            const res = await axios.get(Api.APP_URL_API+url);
            return res;
        } catch (error) {
            console.error(error.message);
        }
    }
}